/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDeptsController', ProjectDeptsController);

    ProjectDeptsController.$inject = ['entity', '$state', '$http', '$stateParams'];

    function ProjectDeptsController(entity, $state, $http, $stateParams) {
        var vm = this;
        vm.project = entity;

        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.depts = [];

        $http.get('api/board/projects/depts', {
            params: {
                projectId: entity.id
            }
        }).then(function (response) {
            vm.depts = response.data;
        });

        // could be replaced with vm.project.bookedPlaces but this way it gets refreshed every time (not only with project reload)
        $http.get('api/board/bookings/summary', {
            params: {
                projectID: entity.id
            }
        }).then(function (response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.project.places - vm.validPlaces
        });

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/projects/export/', {
                params: {
                    projectId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();
